(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // ---------- Side cart drawer ----------
  var drawer = null;
  function money(c) { return '$' + (c / 100).toLocaleString('es-MX', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sized(url, w) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }

  function buildDrawer() {
    if (drawer) return drawer;
    drawer = document.createElement('div');
    drawer.className = 'cg cg-drawer';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML = '<div class="cg-drawer__overlay" data-cg-close></div>' +
      '<aside class="cg-drawer__panel" role="dialog" aria-modal="true" aria-label="Carrito">' +
      '<div class="cg-drawer__head"><span>Tu carrito</span><button type="button" class="cg-drawer__x" data-cg-close aria-label="Cerrar">×</button></div>' +
      '<div class="cg-drawer__body" data-cg-items></div><div class="cg-drawer__foot" data-cg-foot></div></aside>';
    document.body.appendChild(drawer);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cg-close]')) { closeDrawer(); return; }
      var q = e.target.closest('[data-cg-qty]');
      if (q) change(q.dataset.key, Number(q.dataset.cgQty));
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    return drawer;
  }

  function updateCount(n) {
    var icon = document.querySelector('.cg-header__icons a[href*="/cart"]');
    if (!icon) return;
    var badge = icon.querySelector('.cg-count');
    if (!n) { if (badge) badge.remove(); return; }
    if (!badge) { badge = document.createElement('span'); badge.className = 'cg-count'; icon.appendChild(badge); }
    badge.textContent = n;
  }

  function lineMeta(it) {
    var parts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(o.name) + ': ' + esc(o.value); });
    var props = it.properties || {};
    Object.keys(props).forEach(function (k) { if (k.charAt(0) !== '_' && props[k] && !(it.options_with_values || []).some(function (o) { return o.name === k; })) parts.push(esc(k) + ': ' + esc(props[k])); });
    return parts.length ? '<span class="cg-line__var">' + parts.join('<br>') + '</span>' : '';
  }

  function render(cart) {
    var items = drawer.querySelector('[data-cg-items]'), foot = drawer.querySelector('[data-cg-foot]');
    updateCount(cart.item_count);
    if (!cart.item_count) {
      items.innerHTML = '<div class="cg-drawer__empty"><p>Tu carrito está vacío.</p><button type="button" class="cg-atc" data-cg-close>Seguir comprando</button></div>';
      foot.innerHTML = '';
      return;
    }
    items.innerHTML = cart.items.map(function (it) {
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '<div class="cg-line">' +
        '<a href="' + it.url + '" class="cg-line__img">' + (it.image ? '<img src="' + sized(it.image, 200) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="cg-line__info"><a href="' + it.url + '" class="cg-line__title">' + esc(it.product_title) + '</a>' +
        lineMeta(it) +
        '<div class="cg-line__row"><div class="cg-qty">' +
        '<button type="button" data-cg-qty="' + (it.quantity - 1) + '" data-key="' + it.key + '" aria-label="Quitar una unidad">−</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-cg-qty="' + (it.quantity + 1) + '" data-key="' + it.key + '" aria-label="Añadir una unidad">+</button></div>' +
        '<span class="cg-line__price">' + was + '<b>' + money(it.final_line_price) + '</b></span></div>' +
        '<button type="button" class="cg-line__rm" data-cg-qty="0" data-key="' + it.key + '">Eliminar</button></div></div>';
    }).join('');
    var saved = cart.original_total_price - cart.total_price;
    foot.innerHTML = (saved > 0 ? '<div class="cg-drawer__save"><span>Ahorro por cantidad</span><b>−' + money(saved) + '</b></div>' : '') +
      '<div class="cg-drawer__total"><span>Subtotal</span><b>' + money(cart.total_price) + '</b></div>' +
      '<p class="cg-drawer__ship">🚚 Envío gratis a todo México</p>' +
      '<a class="cg-atc cg-drawer__checkout" href="' + root + 'checkout">Finalizar compra</a>' +
      '<button type="button" class="cg-drawer__more" data-cg-close>Seguir comprando</button>';
  }

  function refresh() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(render); }
  function change(key, qty) {
    drawer.classList.add('is-busy');
    fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) })
      .then(function (r) { return r.json(); }).then(render)
      .finally(function () { drawer.classList.remove('is-busy'); });
  }
  function openDrawer() {
    buildDrawer();
    return refresh().then(function () {
      drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    });
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.cg-header__icons a[href*="/cart"]');
    if (a && document.body.classList.contains('cg-body')) { e.preventDefault(); openDrawer(); }
  });

  window.cgOpenDrawer = openDrawer;

  function init(scope) {
    scope.querySelectorAll('[data-cg-buy]').forEach(function (box) {
      if (box.dataset.ready) return; box.dataset.ready = '1';
      var sizes = box.querySelectorAll('[data-cg-size]'), label = box.querySelector('[data-cg-size-label]'), variant = null;
      function pick(b) { sizes.forEach(function (x) { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', x === b); }); variant = b.dataset.variant; label.textContent = b.textContent; }
      sizes.forEach(function (b) { b.addEventListener('click', function () { pick(b); }); });
      if (sizes.length) pick(sizes[0]);
      document.querySelectorAll('[data-cg-atc]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.dataset.scroll && box.getBoundingClientRect().bottom < 0) { box.scrollIntoView({ behavior: 'smooth' }); return; }
          var text = btn.textContent; btn.textContent = 'Agregando…'; btn.setAttribute('aria-busy', 'true');
          fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }] }) })
            .then(function (r) { if (!r.ok) throw r; return openDrawer(); })
            .catch(function () { alert('No se pudo agregar al carrito. Inténtalo de nuevo.'); })
            .finally(function () { btn.textContent = text; btn.removeAttribute('aria-busy'); });
        });
      });
      var sticky = document.querySelector('[data-cg-sticky]'), main = box.querySelector('.cg-atc');
      if (sticky && 'IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); }); }).observe(main);
    });
    scope.querySelectorAll('[data-cg-open]').forEach(function (b) {
      if (b.dataset.ready) return; b.dataset.ready = '1';
      b.addEventListener('click', function () { var m = document.getElementById(b.dataset.cgOpen); if (m) m.classList.add('is-open'); });
    });
    scope.querySelectorAll('.cg-modal').forEach(function (m) {
      if (m.dataset.ready) return; m.dataset.ready = '1';
      m.addEventListener('click', function (e) { if (e.target === m || e.target.closest('.cg-modal__close')) m.classList.remove('is-open'); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
